import { render, staticRenderFns } from "./Gain.vue?vue&type=template&id=e3005038&scoped=true&"
import script from "./Gain.vue?vue&type=script&lang=js&"
export * from "./Gain.vue?vue&type=script&lang=js&"
import style0 from "./Gain.vue?vue&type=style&index=0&id=e3005038&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3005038",
  null
  
)

export default component.exports